import { render } from "./GrossProductUpdate.vue?vue&type=template&id=5d620e76&scoped=true"
import script from "./GrossProductUpdate.vue?vue&type=script&lang=js"
export * from "./GrossProductUpdate.vue?vue&type=script&lang=js"

import "./GrossProductUpdate.vue?vue&type=style&index=0&id=5d620e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d620e76"]])

export default __exports__